/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_OtherInputs */

const vi_care_log_activity_other = /** @type {(inputs: Care_Log_Activity_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác`)
};

/**

* @param {Care_Log_Activity_OtherInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_other = /** @type {((inputs?: Care_Log_Activity_OtherInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_OtherInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_other(inputs)
});